import * as tslib_1 from "tslib";
import { setMailboxMessageConfiguration } from 'owa-options-core';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { action, select } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { logUsage } from 'owa-analytics';
var saveReadingPanePositionOptionStitchName = 'saveReadingPanePositionOptionStitchName';
var saveReadingPaneOption = action('saveReadingPaneOption')(function saveReadingPaneOption(newReadingPanePosition, userOptions, newNextSelection, newLoadFirstMessageOnLogon) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var servicePromises, serverUpdates, showReadingPane, serviceBehavior;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    servicePromises = [];
                    serverUpdates = [];
                    showReadingPane = newReadingPanePosition != ReadingPanePosition.Off;
                    // Deal with the new ReadingPane position
                    if (newReadingPanePosition !== userOptions.GlobalReadingPanePositionReact) {
                        userOptions.GlobalReadingPanePositionReact = newReadingPanePosition;
                        // Raise stitch so that, if we're running in mail, it'll trigger 3 line view or single line view
                        raiseAction(saveReadingPanePositionOptionStitchName)(newReadingPanePosition);
                        serverUpdates.push({
                            propertyName: 'GlobalReadingPanePositionReact',
                            propertyType: 'Integer32',
                            propertyValue: String(newReadingPanePosition),
                        });
                    }
                    // Deal with ShowReadingPaneOnFirstLoad
                    if (newLoadFirstMessageOnLogon !== undefined &&
                        newLoadFirstMessageOnLogon !== userOptions.ShowReadingPaneOnFirstLoad) {
                        userOptions.ShowReadingPaneOnFirstLoad = newLoadFirstMessageOnLogon;
                        serverUpdates.push({
                            propertyName: 'ShowReadingPaneOnFirstLoad',
                            propertyType: 'Boolean',
                            propertyValue: "" + userOptions.ShowReadingPaneOnFirstLoad,
                        });
                    }
                    // Send request to update RP position and ShowReadingPaneOnFirstLoad
                    if (serverUpdates.length) {
                        servicePromises.push(updateUserConfiguration(serverUpdates));
                    }
                    // Deal with the new 'NextSelection'
                    if (showReadingPane && (newNextSelection || userOptions.NextSelection) == 'ReturnToView') {
                        newNextSelection = 'Next';
                    }
                    if (newNextSelection && newNextSelection !== userOptions.NextSelection) {
                        userOptions.NextSelection = newNextSelection;
                        serviceBehavior = void 0;
                        switch (userOptions.NextSelection) {
                            case 'Previous':
                                serviceBehavior = 0 /* OpenPreviousItem */;
                                break;
                            case 'Next':
                                serviceBehavior = 1 /* OpenNextItem */;
                                break;
                            case 'ReturnToView':
                                serviceBehavior = 2 /* ReturnToView */;
                                break;
                        }
                        servicePromises.push(setMailboxMessageConfiguration({
                            AfterMoveOrDeleteBehavior: serviceBehavior,
                        }));
                    }
                    return [4 /*yield*/, Promise.all(servicePromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
export var saveReadingPaneOptionFull = select({
    userOptions: function () { return getUserConfiguration().UserOptions; },
    optionState: function () { return store; },
})(action('saveReadingPaneOptionFull')(function saveReadingPaneOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, optionState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = state.userOptions, optionState = state.optionState;
                    return [4 /*yield*/, saveReadingPaneOption(getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact), userOptions, optionState.nextSelection || userOptions.NextSelection, getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingReadingPane';
export var saveReadingPaneOptionQuick = select({
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveReadingPaneOptionQuick')(function saveReadingPaneOptionQuick(newReadingPanePosition, state) {
    var readingPanePositionString;
    switch (newReadingPanePosition) {
        case ReadingPanePosition.Off:
            readingPanePositionString = 'Off';
            break;
        case ReadingPanePosition.Right:
            readingPanePositionString = 'Right';
            break;
        case ReadingPanePosition.Bottom:
            readingPanePositionString = 'Bottom';
            break;
        default:
            readingPanePositionString = 'Unknown';
            break;
    }
    logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [readingPanePositionString]);
    saveReadingPaneOption(newReadingPanePosition, state.userOptions);
}));
//# sourceMappingURL=saveReadingPaneOption.js.map